import { icons } from "assets/AssetHelper";
import CustomerAddresses from "components/Molecules/users/customers/customerAddresses";
import CustomerProfileInfo from "components/Molecules/users/customers/customerProfileInfo";
import dayjs from "dayjs";
import ViewAllBtn from "components/Molecules/users/customers/viewAllBtn";

export const detailsData = ({
  data,
  followers,
  followings,
  setAddressesToShow,
  addressesToShow,
  getFollowingList,
  getFollowersList,
  followingslist,
  followersList,
  t,
}) => [
  {
    head: t("details.customer_image"),
    icon: icons?.media,
    details: [
      {
        name: (
          <CustomerProfileInfo
            data={data}
            followers={followers}
            followings={followings}
            getFollowingList={getFollowingList}
            getFollowersList={getFollowersList}
            followingslist={followingslist}
            followersList={followersList}
          />
        ),
        width: "100%",
      },
    ],
  },
  {
    head: t("details.personal_information"),
    icon: icons?.details,
    details: [
      {
        label: t("details.phone"),
        name: data?.phone_number,
      },
      {
        label: t("details.birthdate"),
        name: dayjs(data?.birthdate).format("DD / MM / YYYY "),
      },
    ],
  },
  data?.addresses?.length > 0 && {
    head: (
      <ViewAllBtn
        setAddressesToShow={setAddressesToShow}
        addressesToShow={addressesToShow}
        data={data?.addresses}
      />
    ),
    icon: icons?.locationOutlined,
    details: [
      {
        name: (
          <CustomerAddresses
            data={data?.addresses}
            addressesToShow={addressesToShow}
          />
        ),
        width: "100%",
      },
    ],
  },
  {
    head: t("details.dates"),
    icon: icons?.dates,
    details: [
      {
        label: t("details.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("details.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("details.last_sign_in_at"),
        name: dayjs(data?.last_sign_in_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
